import { ErrorBoundary } from '@/components/Rollbar';
import { Error5XX } from '@/features/errors/5XX';
import { FC, memo, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const GlobalErrorBoundary: FC<Props> = memo(({ children }) => {
  return (
    <ErrorBoundary shouldPropagate={false} fallback={Error5XX}>
      {children}
    </ErrorBoundary>
  );
});
GlobalErrorBoundary.displayName = 'GlobalErrorBoundary';
